export const DEPARTMENT_GET_REQUEST = 'DEPARTMENT_GET_REQUEST';
export const DEPARTMENT_GET_SUCCESS = 'DEPARTMENT_GET_SUCCESS';
export const DEPARTMENT_GET_ERROR = 'DEPARTMENT_GET_ERROR';
export const DEPARTMENT_GET_BY_KEY_REQUEST = 'DEPARTMENT_GET_BY_KEY_REQUEST';
export const DEPARTMENT_GET_BY_KEY_SUCCESS = 'DEPARTMENT_GET_BY_KEY_SUCCESS';
export const DEPARTMENT_GET_BY_KEY_ERROR = 'DEPARTMENT_GET_BY_KEY_ERROR';
export const DEPARTMENT_ADD_REQUEST = 'DEPARTMENT_ADD_REQUEST';
export const DEPARTMENT_ADD_SUCCESS = 'DEPARTMENT_ADD_SUCCESS';
export const DEPARTMENT_ADD_ERROR = 'DEPARTMENT_ADD_ERROR';
export const DEPARTMENT_EDIT_REQUEST = 'DEPARTMENT_EDIT_REQUEST';
export const DEPARTMENT_EDIT_SUCCESS = 'DEPARTMENT_EDIT_SUCCESS';
export const DEPARTMENT_EDIT_ERROR = 'DEPARTMENT_EDIT_ERROR';
export const DEPARTMENT_DELETE_REQUEST = 'DEPARTMENT_DELETE_REQUEST';
export const DEPARTMENT_DELETE_SUCCESS = 'DEPARTMENT_DELETE_SUCCESS';
export const DEPARTMENT_DELETE_ERROR = 'DEPARTMENT_DELETE_ERROR';
